export const isAlgoliaCacheValid = (pathname: string) => {
    const sessionPageUpdated = parseInt(
        sessionStorage.getItem(`algoliaUpdateCache-${pathname}`) || '0'
    );
    const currentTime = Math.floor(Date.now() / 1000);
    return currentTime - sessionPageUpdated < 86400;
};

export const invalidateCache = (pathname: string) => {
    sessionStorage.removeItem(`algoliaParams-${pathname}`);
    sessionStorage.removeItem(`algoliaHits-${pathname}`);
    sessionStorage.removeItem(`algoliaUpdateCache-${pathname}`);
};
